/**
 * Utility module to augment ramda with anything it's missing.
 */
import { allPass, complement, is, path, Path } from 'ramda';
// eslint-disable-next-line no-restricted-imports
import {
  throttle as lodashThrottle,
  debounce as lodashDebounce,
  random as lodashRandom,
} from 'lodash';

export const isNotNil = <T>(v: T | undefined | null): v is T =>
  v !== undefined && v !== null;

export const getOr = <T>(p: Path, defaultVal: T, obj: object | null | void) =>
  path<T>(p, obj) || defaultVal;

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
export const noop = (...args: any[]): void => undefined;

export const throttle = lodashThrottle;
export const debounce = lodashDebounce;
export const random = lodashRandom;
declare module 'ramda' {
  // eslint-disable-next-line @typescript-eslint/interface-name-prefix
  interface Filter {
    <T>(fn: (value: T) => boolean): (list: readonly T[]) => T[];
    <T>(fn: (value: T) => boolean, list: readonly T[]): T[];
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isNumber = <T extends any>(val: T | number): val is number =>
  is(Number)(val);

export const isNumberBetween: (
  start: number,
  end: number
) => (number: number) => boolean = (start, end) => number =>
  start <= number && number < end;

export const isNumberAndBetween: (
  start: number,
  end: number
) => (number?: number) => boolean = (start, end) =>
  allPass([complement(isNaN), isNumber, isNumberBetween(start, end)]);
